"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../../config");
var styles = {
    img: { width: "100%", height: "auto" },
};
var StationQR = react_1.default.memo(function (_a) {
    var station = _a.station;
    var appStationURL = "".concat(config_1.APP_BASE_URL, "/stations/detail/").concat(station.id);
    return react_1.default.createElement("div", null,
        react_1.default.createElement("img", { src: "".concat(config_1.API_BASE_URL, "/stations/").concat(station.id, "/qr"), style: styles.img, alt: "Station QR: ".concat(station.title) }),
        react_1.default.createElement("a", { href: appStationURL }, appStationURL));
});
exports.default = StationQR;
